import categoryApi from '@/services/plataforma/categories';

export default {
  async getAllCategories({ commit }) {
    const categories = await categoryApi.getAllCategories();
    if (categories.status === 200) {
      commit('SET_CATEGORIES', categories.data);

      return categories.data;
    }
  },
  async getMyCategories({ commit }, { flat, appendDisciplines, isVisible } = {}) {
    return categoryApi.getMyCategories({ flat, appendDisciplines, isVisible })
      .then(response => {
        commit('SET_MY_CATEGORIES', response.data.categories);
        commit('SET_MY_CATEGORIES_COUNT', response.data.totalCategories);
        commit('SET_MY_DISCIPLINES_COUNT', response.data.totalDisciplines);
        return Promise.resolve(response.data.categories);
      })
      .catch(e => Promise.reject(e.response));
  },
  async getCategoryById({ commit }, id) {
    const categories = await categoryApi.getCategoryById(id);
    if (categories.status === 200) {
      return categories.data;
    }
  },
  async deleteCategory({ commit }, id) {
    const categories = await categoryApi.deleteCategory(id);
    if (categories.status === 204) {
      return categories.data;
    }
  },
  async editCategory({ commit }, category) {
    try {
      const categories = await categoryApi.editCategory(category);
      if (categories.status === 200) {
        return categories.data;
      }
    } catch (e) {
      return false;
    }
  },
  async createCategory({ commit }, category) {
    try {
      const categories = await categoryApi.createCategory(category);
      if (categories.status === 201) {
        return categories.data;
      }
    } catch (e) {
      return false;
    }
  },
  async setCategories({ commit }, parameters) {
    commit('SET_CATEGORIES', parameters);
  }
};
